import { getFunctions } from '../helpers'

// if (process.env.NODE_ENV === 'development') {
//   getFunctions().useEmulator('localhost', 5001)
// }

export const callSearchGameTitles = (data) =>
  getFunctions().httpsCallable('searchGameTitles')(data)

export const callRegisterGameTitle = (data) =>
  getFunctions().httpsCallable('registerGameTitle')(data)
